import { NavigationGuard } from 'vue-router';
import sl from '@/serviceLocator';

const authenticatedGuard: NavigationGuard = () => {
  const store = sl.get('store');

  if (store.getters.isAuthenticated) {
    return true;
  }
  return '/401';
};

export default authenticatedGuard;
